module.exports = __webpack_public_path__ + "platform-web/static/media/user.f488a721.svg";